import { ChakraFlex, InputGroupV2 } from '@equip.health/ui';
import { ReactElement } from 'react';

interface InputColumnProps {
  children: JSX.Element;
  id: string;
  isRequired?: boolean;
  label: string;
  toolTip?: ReactElement<any, any>;
}

export const InputColumn = ({
  children,
  id,
  isRequired = false,
  label,
  toolTip,
}: InputColumnProps) => {
  const labelElement = toolTip ? (
    <ChakraFlex alignItems="center" gap="6px">
      {label} {toolTip}
    </ChakraFlex>
  ) : (
    label
  );
  return (
    <ChakraFlex flex="1 0" gap="12px">
      <InputGroupV2
        id={id}
        isRequired={isRequired}
        label={labelElement as string}
      >
        {children}
      </InputGroupV2>
    </ChakraFlex>
  );
};
